import "./style.scss";

const BODY_LOCK_CLASS = "is-nav-locked";

const init = () => {
    const header = document.getElementById("site-header");
    if (!header) return;

    const hamburger = header.querySelector(".site-header__hamburger");
    const closeBtn = header.querySelector(".site-header__close");
    const overlay = header.querySelector(".site-header__overlay");
    if (!hamburger || !closeBtn || !overlay) return;

    const overlayLinks = overlay.querySelectorAll("a");

    const open = () => {
        overlay.removeAttribute("hidden");
        hamburger.setAttribute("aria-expanded", "true");
        document.body.classList.add(BODY_LOCK_CLASS);
        closeBtn.focus();
    };

    const close = () => {
        overlay.setAttribute("hidden", "");
        hamburger.setAttribute("aria-expanded", "false");
        document.body.classList.remove(BODY_LOCK_CLASS);
        hamburger.focus();
    };

    hamburger.addEventListener("click", open);
    closeBtn.addEventListener("click", close);
    overlayLinks.forEach((link) => link.addEventListener("click", close));
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && hamburger.getAttribute("aria-expanded") === "true") {
            close();
        }
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}
